import { Form, Switch } from "antd";
import { ConfigurationEditorMiniComponent } from "components/common/configuration-editor-mini";
import { MultiChannelWidgetSettingsInner } from "./multi-channel-widget-settings-inner";

export const MultiChannelWidgetSettings = ({
  entityId,
}: {
  entityId: string;
}) => {
  return (
    <ConfigurationEditorMiniComponent
      icon={"ri-chat-smile-2-line"}
      title="Multi Channel Widget"
      description="Enable support through multiple channels for your widget"
      entityId={entityId}
      entityType="WIDGET"
      formLayout="horizontal"
      labelCol={{ span: 9 }}
    >
      <Form.Item
        name={["configurations", "multiChannelConfig", "isEnabled"]}
        label={"Enable Widget"}
        rules={[]}
        valuePropName="checked"
      >
        <Switch size="small" />
      </Form.Item>

      <Form.Item shouldUpdate noStyle>
        {() => <MultiChannelWidgetSettingsInner />}
      </Form.Item>
      <div className="m-4"></div>
    </ConfigurationEditorMiniComponent>
  );
};
